import { default } from '../app/router.options';
<script lang="ts" setup>
const props = defineProps({
    total: {
        required: true,
        type: Number as PropType<number>,
        default: 0
    },
    page: {
        type: Number,
        default: 1
    },
    perPage: {
        type: Number,
        default: 12
    },
    pagerCount: {
        type: Number,
        default: 5
    },
    layout: {
        type: String,
        default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
        type: Boolean,
        default: false
    },
    autoScroll: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: false
    },
    handleChangePage: {
        type: Function,
        default: () => { }
    }
})

const emit = defineEmits(['update:page', 'update:perPage', 'pagination'])

const currentPage = computed<number | undefined>({
    get: () => props.page,
    set: value => {
        emit('update:page', value)
    }
})

function handleCurrentChange(val: number) {
    props.handleChangePage(val)
    currentPage.value = val
    emit('pagination', { page: val, perPage: props.perPage })
}
</script>

<template>
    <div :class="{ hidden: hidden }">
        <el-pagination class="h-pagination center" :background="background" :page-size="perPage" :pager-count="pagerCount"
            v-model:current-page="currentPage" :layout="layout" :total="total" @current-change="handleCurrentChange" />
    </div>
</template>

<style lang="scss" scoped></style>